import React, { useEffect, useState } from 'react';
import styles from './DetailedWorkDetails.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { NextButton } from '../../../Common/CtaButton/NextButton';
import { TextInput } from '../../../Common/TextInput';
import {
    DETAILED_JOB_DETAILS_MAX_LENGTH,
    DETAILED_JOB_DETAILS_MIN_LENGTH,
} from '../../../../constants/progressBanner';
import {
    HandleDetailedJobDetailsBlurType,
    ValidateDetailedJobDetailsType,
    ValidateFormType,
} from './types';

export const DetailedWorkDetails: React.FC = () => {
    const [detailedJobDetails, setDetailedJobDetails] = useState<string>('');
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [detailedJobDetailsError, setDetailedJobDetailsError] =
        useState<string>('');

    const validateDetailedJobDetails: ValidateDetailedJobDetailsType = (
        value,
        isBlurEvent = false
    ) => {
        if (!value) {
            return isBlurEvent ? '入力してください' : '';
        }

        if (value.length < DETAILED_JOB_DETAILS_MIN_LENGTH) {
            return `${DETAILED_JOB_DETAILS_MIN_LENGTH}文字以上入力してください`;
        }

        if (value.length > DETAILED_JOB_DETAILS_MAX_LENGTH) {
            return `${DETAILED_JOB_DETAILS_MAX_LENGTH}文字以内で入力してください`;
        }

        return '';
    };


    const validateForm: ValidateFormType = (value, isBlurEvent = false) => {
        const error = validateDetailedJobDetails(value, isBlurEvent);
        setDetailedJobDetailsError(error);
        setIsFormValid(error === '' && value.length > 0);
    };

    useEffect(() => {
        validateForm(detailedJobDetails);
    }, [detailedJobDetails]);

    const handleDetailedJobDetailsBlur: HandleDetailedJobDetailsBlurType =
        () => {
            validateForm(detailedJobDetails, true);
        };

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText="詳しい仕事内容は？"
                        dataViewLabel="EF_詳しい仕事内容_pv"
                        dataClickLabel="EF_詳しい仕事内容_戻る"
                    />
                </div>
                <div className={styles.supplement}>
                    <div>
                        <p className={styles.meritText}>
                            情報を見て企業からスカウトが届くかも！
                        </p>
                    </div>
                    <p className={styles.explanationText}>
                        登録内容を充実させることで企業からの
                        <br />
                        <span className={styles.scoutText}>スカウト</span>
                        が届きやすくなります
                    </p>
                </div>
                <div className={styles.companyField}>
                    <TextInput
                        text="イタリアンレストランの○○店にて3年間接客や調理、仕込みなど基本的な現場業務に携わり、その後店長として3年間、売上げ管理や、アルバイト・新入社員のマネジメントやメニュー開発に従事。"
                        value={detailedJobDetails}
                        onChange={setDetailedJobDetails}
                        onBlur={handleDetailedJobDetailsBlur}
                    />
                    <div className={styles.errorMessagesWrapper}>
                        {detailedJobDetailsError && (
                            <p className={styles.errorMessages}>
                                {detailedJobDetailsError}
                            </p>
                        )}
                    </div>
                </div>
                <NextButton
                    formKey={['userResumesAttributes', 'detailedJobDetails']}
                    formValue={[0, detailedJobDetails]}
                    isDisabled={!isFormValid}
                    confirmation={'確認画面へ'}
                    displayFormKey={'detailedJobDetails'}
                    displayFormValue={detailedJobDetails}
                    dataClickLabel="EF_詳しい仕事内容_確認画面へ"
                />
            </div>
        </div>
    );
};
